@if (updateService.showBanner()) {
	<div
		class="fixed bottom-4 left-1/2 z-[9999] w-[calc(100%-2rem)] max-w-3xl -translate-x-1/2 rounded-2xl bg-mainColor shadow-xl"
		role="alert"
	>
		<div class="flex flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:gap-5 sm:px-5 sm:py-4">
			<div class="flex min-w-0 flex-1 items-start gap-3 sm:items-center sm:gap-4">
				<i class="fa-solid fa-circle-up shrink-0 text-3xl text-accentColor" aria-hidden="true"></i>

				<div class="flex min-w-0 flex-col gap-0.5">
					<p class="font-bold text-white text-sm sm:text-base">Dostępna jest nowa wersja aplikacji</p>
					<p class="text-xs text-white/70 sm:text-sm">Odśwież, aby skorzystać z najnowszych ulepszeń.</p>
				</div>
			</div>

			<div class="flex shrink-0 items-center justify-end gap-3 sm:gap-4">
				<button
					type="button"
					class="flex items-center gap-2 rounded-full bg-accentColor px-5 py-2.5 text-sm font-bold text-white hover:bg-accentHoverColor sm:text-base"
					(click)="updateService.applyUpdate()"
				>
					<i class="fa-solid fa-rotate-right text-white"></i>
					Odśwież
				</button>

				<button
					type="button"
					class="p-1 text-white hover:text-white/70"
					aria-label="Zamknij"
					(click)="updateService.dismissBanner()"
				>
					<i class="fa-solid fa-xmark text-lg"></i>
				</button>
			</div>
		</div>
	</div>
}
